import {
  SERVICES_IOS_ROUTE,
  SERVICES_ANDROID_ROUTE,
  CUSTOM_ECOMMERCE_DEVELOPMENT,
  SERVICES_AR_ROUTE,
  SPORTS_APP_DEVELOPMENT,
  RESTAURANT_APP_DEVELOPMENT_ROUTE,
  SERVICES_BRANDING_ROUTE,
  SERVICES_DIGITAL_TRANSFORMATION_ROUTE,
  SERVICES_BACKEND_ROUTE,
  SERVICES_FRONTEND_ROUTE,
  VISION_PRO_DEVELOPMENT_COMPANY,
  FINTECH_APP_DEVELOPMENT,
  HEALTHCARE_APP_DEVELOPMENT_COMPANY,
  IOT_DEVELOPMENT_SERVICES_ROUTE,
  LIVE_STREAMING_SHOPPING_DEVELOPMENT_ROUTE,
  AI_DEVELOPMENT_COMPANY_ROUTE,
  FITNESS_WELLNESS_APP_DEVELOPMENT_ROUTE,
  SERVICES_PERFORMANCE_MARKETING_ROUTE,
  SERVICES_MOBILE_APP_ROUTE,
  SERVICES_WEB_DEVELOPMENT_ROUTE,
} from 'routes/constants'

export const tags = [
  {
    route: SERVICES_BRANDING_ROUTE,
    value: 'Branding',
  },
  {
    route: SERVICES_ANDROID_ROUTE,
    value: 'Android',
  },
  {
    route: SERVICES_AR_ROUTE,
    value: 'A/R',
  },
  {
    route: SERVICES_IOS_ROUTE,
    value: 'iOS',
  },
  {
    route: RESTAURANT_APP_DEVELOPMENT_ROUTE,
    value: 'Restaurant',
  },
  {
    route: CUSTOM_ECOMMERCE_DEVELOPMENT,
    value: 'Retail',
  },
  {
    route: SPORTS_APP_DEVELOPMENT,
    value: 'Sports',
  },
  {
    route: SERVICES_DIGITAL_TRANSFORMATION_ROUTE,
    value: 'Digital Transformation',
  },
  {
    route: SERVICES_BACKEND_ROUTE,
    value: 'Backend',
  },
  {
    route: SERVICES_FRONTEND_ROUTE,
    value: 'Frontend',
  },
  {
    route: FINTECH_APP_DEVELOPMENT,
    value: 'Fintech',
  },
  {
    route: VISION_PRO_DEVELOPMENT_COMPANY,
    value: 'Vision Pro',
  },
  {
    route: HEALTHCARE_APP_DEVELOPMENT_COMPANY,
    value: 'Healthcare',
  },
  {
    route: IOT_DEVELOPMENT_SERVICES_ROUTE,
    value: 'IoT',
  },
  {
    route: LIVE_STREAMING_SHOPPING_DEVELOPMENT_ROUTE,
    value: 'Live Streaming Shopping',
  },
  {
    route: AI_DEVELOPMENT_COMPANY_ROUTE,
    value: 'AI',
  },
  {
    route: FITNESS_WELLNESS_APP_DEVELOPMENT_ROUTE,
    value: 'Fitness & Wellness',
  },
  {
    route: SERVICES_PERFORMANCE_MARKETING_ROUTE,
    value: 'Performance Marketing',
  },
  {
    route: SERVICES_MOBILE_APP_ROUTE,
    value: 'Mobile App Development',
  },
  {
    route: SERVICES_WEB_DEVELOPMENT_ROUTE,
    value: 'Web Development',
  },
]
